import React from 'react';

import FormattedDate, { DEFAULT_DATE_TIME_FORMAT } from './FormattedDate';
import KilometerValue from './KilometerValue';
import WarningForOldTimestamp from './WarningForOldTimestamp';

interface TimestampAndMileageProps {
    timestamp?: string | number | Date;
    mileage?: number;
    className?: string;
    withWarning?: boolean;
    prefix?: string;
    postfix?: string;
    hideMissingMileage?: boolean;
    dateFormat?: Intl.DateTimeFormatOptions;
}

export const TimestampAndMileage: React.FC<TimestampAndMileageProps> = ({
    timestamp,
    mileage,
    className = '',
    withWarning = true,
    prefix = '',
    postfix = '',
    hideMissingMileage = false,
    // dateFormat = 'DD/MM/YYYY HH:mm'
    dateFormat = DEFAULT_DATE_TIME_FORMAT,
}) => {
    if (!timestamp && !mileage) {
        return <div className={`display-flex flex-wrap text-color-dark ${className}`}>-</div>;
    }

    const hideMileage = hideMissingMileage && !mileage;

    return (
        <div className={`display-flex flex-wrap text-color-dark ${className}`}>
            <span>
                {prefix}
                <FormattedDate date={timestamp} dateFormat={dateFormat} />
            </span>
            {!hideMileage && (
                <span className="display-inline-block align-center">
                    &nbsp;|&nbsp;
                    <KilometerValue value={mileage} />
                    {withWarning && <WarningForOldTimestamp timestamp={timestamp} />}
                </span>
            )}
            <span className="display-inline-block align-center">{postfix}</span>
        </div>
    );
};

export default TimestampAndMileage;
